<template>
  <figure :class="{ circle }">
    <img
      v-if="image"
      v-lazy="url"
      :key="image.url"
      :data-zoom-src="image.url"
      ref="image"
    />
    <img v-else v-lazy="fallback" :key="fallback" />
  </figure>
</template>

<script>
import mediumZoom from "medium-zoom";
import fallback from "@/assets/images/fallback.svg";

export default {
  name: "LazyImage",
  props: {
    image: Object,
    size: { type: String },
    circle: { type: Boolean, default: false },
    zoom: { type: Boolean, default: false },
  },
  data() {
    return {
      fallback: fallback,
      zoomInstance: null,
    };
  },
  computed: {
    url() {
      if (this.size) {
        return this.image.sizes
          ? this.image.sizes[this.size] || this.image.url
          : this.image.url;
      } else {
        return this.image.url;
      }
    },
  },
  methods: {
    attachZoom() {
      if (this.zoom && this.$refs.image && !this.zoomInstance) {
        this.zoomInstance = mediumZoom(this.$refs.image, { margin: 20 });
      }
    },
    detachZoom() {
      if (this.zoomInstance) {
        this.zoomInstance.detach();
        this.zoomInstance = null;
      }
    },
    setIntrinsicWidth() {
      if (this.image && this.image.width && this.$refs.image) {
        this.$refs.image.style.setProperty(
          "--intrinsic-width",
          `${this.image.width}px`
        );
      }
    },
  },
  beforeUpdate() {
    this.detachZoom();
  },
  beforeDestroy() {
    this.detachZoom();
  },
  updated() {
    this.attachZoom();
    this.setIntrinsicWidth();
  },
  mounted() {
    this.attachZoom();
    this.setIntrinsicWidth();
  },
};
</script>

<style scoped>
figure.circle {
  position: relative;
  overflow: hidden;
  height: 0;
  padding-bottom: 100%;
  border: 1px solid #000;
  border-radius: 22%;
}

figure.circle img {
  position: absolute;
  top: 0px;
  left: 0px;
  height: calc(100% + 2px);
  width: calc(100% + 2px);
  object-fit: cover;
  object-position: center;
}
</style>

<style>
.medium-zoom-overlay {
  z-index: 997;
  opacity: 0 !important;
}
.medium-zoom-image {
  z-index: 998;
}
.medium-zoom-image:last-child {
  z-index: 999;
}
</style>
